import { Card, CardContent, CardDescription, CardFooter, CardTitle } from '@/components/ui/card';
import { focusRingClassNames, themeColorLinkClassNames } from '@/components/ui/utils';
import { LESSON_ACTION_LABEL, lessonLaunchTracking, type LessonState } from '@/pages/Explore/Lessons/lessonState';
import { trackingAttributes } from '@/lib/heap/trackingAttributes';
import { cn } from '@/lib/utils';
import 'material-symbols';

export interface HubLessonCardProps {
    title: string;
    state: LessonState;
    onPlay: () => void;
    description?: string | null;
    imageUrl?: string;
}

export const HubLessonCard = ({ title, state, onPlay, description, imageUrl }: HubLessonCardProps) => (
    <Card
        withBorder
        noPadding
        shadow="sm"
        cursorPointer
        className={cn(
            'group relative h-[344px] overflow-hidden transition-colors sm:h-[380px]',
            'light:hover:bg-surface-dark dark:bg-gz-bluebell-500 dark:hover:bg-gz-blue-700',
        )}
    >
        <div className="min-h-0 flex-1 p-4 pb-0">
            <div className="relative h-full w-full overflow-hidden rounded-xl bg-muted">
                {imageUrl && <img src={imageUrl} alt="" className="absolute inset-0 size-full object-cover" />}
            </div>
        </div>
        <CardContent className="flex flex-none flex-col gap-2 px-4 pt-4 pb-2">
            <CardTitle className="line-clamp-2 type-headline-xsmall light:text-foreground dark:text-foreground" title={title}>
                {title}
            </CardTitle>
            {description && <CardDescription className="line-clamp-3 type-body-default">{description}</CardDescription>}
        </CardContent>
        <CardFooter className="mt-auto justify-end border-0 px-4 pt-2 pb-4">
            <button
                type="button"
                onClick={onPlay}
                aria-label={`${LESSON_ACTION_LABEL[state]}: ${title}`}
                {...trackingAttributes(lessonLaunchTracking(state, 'hub-panel', 'hub-lesson'))}
                className={cn(
                    'inline-flex items-center gap-1 rounded-sm type-body-default font-medium outline-none',
                    'transition-all group-hover:gap-2 after:absolute after:inset-0',
                    themeColorLinkClassNames,
                    focusRingClassNames,
                )}
            >
                Play
                <span className="material-symbols-rounded text-lg leading-none" aria-hidden>arrow_forward</span>
            </button>
        </CardFooter>
    </Card>
);
